export { CoverageType } from './generated/CoverageType.js';